import React, { useContext } from 'react';
import Context from '../../internal-components/GeneralContext';
import styled from 'styled-components/macro';
import _Image from '../Image';
import Link from '../Link';
import Text from '../Text';
import Privileges from '../CheckPrivileges';
import Animation from '../Animation';

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  width: 100%;
  max-width: 980px;
  background-color: white;
  margin: auto;
  min-height: 60vh;
  padding: 0.8em;
  text-align: center;
  padding-bottom: 10vh;
  ${({ additionalStyle }) => additionalStyle}
`;

const Image = styled(_Image)`
  && {
    max-width: 200px;
    height: auto;
    margin: auto;
  }
`;

const Title = styled(Text)`
  && {
  }
`;

const Description = styled(Text)`
  && {
  }
`;

const EmptyPageStateView = props => {
  const api = useContext(Context);

  return (
    <Wrapper additionalStyle={props.wrapperCSS}>
      <Image src={api.imageSrc}></Image>
      <Title variant={'h1'} content={api.title} />
      <Description content={api.description} />
      <Privileges
        privileges={api.actionPrivileges ? api.actionPrivileges : ['form:read']}
      >
        {api.button ? (
          api.button
        ) : (api.to || api.onLinkClicked) && api.linkText ? (
          <Link
            data-testid={'empty-state-action-link'}
            to={api.to}
            onClick={api.onLinkClicked}
            content={
              api.linkText
                ? api.linkText
                : 'Pass text to be displayed here using the "linkText" prop.'
            }
          />
        ) : null}
      </Privileges>
    </Wrapper>
  );
};

export default EmptyPageStateView;
